(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("LearningItemEditAssignmentModalCtrl", ["learningItemAssignmentLocalizationResource", "learningItemAssignmentResource", "FILE_FORMATS", "data", "messageService", "$scope",
        "$translate", "$timeout", "Upload", learningItemEditAssignmentModalCtrl]);
    function learningItemEditAssignmentModalCtrl(learningItemAssignmentLocalizationResource, learningItemAssignmentResource, FILE_FORMATS, data, messageService, $scope, $translate, $timeout, Upload) {
        var vm = this;
        vm.maxAllowedFiles = 1;
        vm.acceptedFiles = FILE_FORMATS.assignment;
        if (data.assignment) {
            vm.assignment = data.assignment;
            vm.edit = true;
        }
        else
            vm.assignment = {};
        var lang = $translate.proposedLanguage() || $translate.use();
        lang = lang.replace("-", "_");
        vm.tinymceOptions = {
            resize: false,
            height: 300,
            plugins: "autoresize wordcount",
            language: lang
        };
        vm.save = function () {
            vm.saving = true;
            if (!vm.form.$valid) {
                vm.showErrors = true;
                vm.saving = false;
                return;
            }
            if (vm.edit) {
                learningItemAssignmentLocalizationResource.save({ id: vm.assignment.id, localizationId: vm.assignment.localizationId }, vm.assignment, function () {
                    messageService.success("common.changesSaved");
                    vm.saving = false;
                    $scope.$close(vm.assignment);
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.assignment.learningItemId = data.learningItemId;
                vm.assignment.localizationId = data.localizationId;
                learningItemAssignmentResource.save(vm.assignment, function (result) {
                    messageService.success("common.changesSaved");
                    vm.saving = false;
                    $scope.$close(result);
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
        };
        vm.upload = function (file) {
            if (file) {
                vm.saving = true;
                file.upload = Upload.upload({
                    url: "api/learningitems/temp/files",
                    data: {
                        file: file
                    }
                });
                file.upload.then(function (response) {
                    $timeout(function () {
                        if (response.data.length > 0) {
                            vm.assignment.fileName = response.data[0].fileName;
                            vm.assignment.fileUrl = response.data[0].fileUrl;
                            messageService.success("common.dropzone.uploadedFileMessage");
                            vm.progress = 0;
                            vm.saving = false;
                        }
                    });
                }, function (response) {
                    messageService.error(response);
                    vm.progress = 0;
                    vm.saving = false;
                }, function (evt) {
                    vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                });
            }
        };
        vm.removeFile = function () {
            vm.assignment.fileName = null;
            vm.assignment.fileUrl = null;
        };
        vm.validateFile = function () {
            if (vm.assignment.fileName)
                return "maxFiles";
            return true;
        };
    }
})();
